import type { CSSProperties } from "react";
import type { Tone, VectorKind } from "./mappers";

/** Colours from claude-design/HdcReport.design.html, contrast-checked (AA) on the dark panel. */
export const C = {
  white: "#ffffff",
  text: "#c9dbe5",
  muted: "#9fbccb",
  ok: "#6fd6c9",
  okSoft: "#a9ece3",
  warn: "#f6b54b",
  bad: "#ff8a6b",
  danger: "#e2574c",
  card: "rgba(8,26,38,0.68)",
  nav: "rgba(8,26,38,0.72)",
  line: "rgba(255,255,255,0.10)",
  lineStrong: "rgba(255,255,255,0.14)",
  lineSoft: "rgba(255,255,255,0.07)",
  track: "rgba(255,255,255,0.12)",
  activeTab: "rgba(111,214,201,0.16)",
  onWarn: "#2a1a00",
  onBad: "#2a0d00",
  onDanger: "#1f0500",
  onOk: "#0b2737",
};

export const toneColor = (t: Tone): string => {
  switch (t) {
    case "ok":
      return C.ok;
    case "warn":
      return C.warn;
    case "bad":
      return C.bad;
    case "muted":
      return C.muted;
    default:
      return C.text;
  }
};

export const vectorColors: Record<VectorKind, { bg: string; fg: string }> = {
  ok: { bg: "rgba(111,214,201,0.22)", fg: C.okSoft },
  m30: { bg: C.warn, fg: C.onWarn },
  m60: { bg: C.bad, fg: C.onBad },
  // Dark text: white on #e2574c is only ~3.7:1.
  m90: { bg: C.danger, fg: C.onDanger },
  none: { bg: "rgba(255,255,255,0.06)", fg: "#8eaab9" },
  other: { bg: "rgba(255,255,255,0.18)", fg: C.white },
};

export const font: CSSProperties = {
  fontFamily: "'Open Sans', system-ui, sans-serif",
};

export const card: CSSProperties = {
  background: C.card,
  borderRadius: 8,
  boxSizing: "border-box",
  minWidth: 0,
};

export const sectionTitle: CSSProperties = {
  margin: 0,
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: "0.04em",
  color: C.white,
  textTransform: "uppercase",
};

export const tabular: CSSProperties = { fontVariantNumeric: "tabular-nums" };
